module.exports = __webpack_public_path__ + "static/media/Watertower_1.4963f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower/Watertower_1.png
// module id = 1273
// module chunks = 3